import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const CreateDailyExpense = createAsyncThunk(
  'daily-expense-store',
  async (data: {}, thunkAPI) => {
    try {
      return await axios.post(`${api}dua-payments/store-daily-expense`, data)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EditDailyExpense = createAsyncThunk(
  'daily-expense-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/edit-daily-expense/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DeleteDailyExpense = createAsyncThunk(
  'daily-expense-delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/delete-daily-expense/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetDailyExpenseReport = createAsyncThunk(
  'get-daily-expense-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/get-daily-expense-report`, {params})

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DailyExpensePrintReport = createAsyncThunk(
  'daily-expense-print-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/daily-expense-print-report`, {params})

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DailyExpenseExcelReport = createAsyncThunk(
  'daily-expense-excel-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/daily-expense-excel-report`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const GetStaff = createAsyncThunk('get-staff', async (type: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-payments/get-staff/${type}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const CreateStaffTransaction = createAsyncThunk(
  'staff-transaction-store',
  async (data: {}, thunkAPI) => {
    try {
      return await axios.post(`${api}dua-payments/store-staff-transaction`, data)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetJournal = createAsyncThunk('journal-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-payments/list-journal`, {params})
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetJournalDetails = createAsyncThunk('journal-list', async (id: any, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-payments/get-journal-details/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrintJournal = createAsyncThunk('print-journal', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-payments/print-journal/${id}`)

    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const EditStaffTransaction = createAsyncThunk(
  'staff-transaction-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/edit-staff-transaction/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DeleteStaffTransaction = createAsyncThunk(
  'staff-transaction-delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/delete-staff-transaction/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetStaffTransactionReport = createAsyncThunk(
  'staff-transaction-print-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/get-staff-transaction-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StaffTransactionPrintReport = createAsyncThunk(
  'staff-transaction-print-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/staff-transaction-print-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StaffTransactionExcelReport = createAsyncThunk(
  'staff-transaction-exce-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/staff-transaction-exce-report`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const GetCompany = createAsyncThunk('get-company', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-payments/get-company`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const CreateCompanyTransaction = createAsyncThunk(
  'company-transaction-store',
  async (data: {}, thunkAPI) => {
    try {
      return await axios.post(`${api}dua-payments/store-company-transaction`, data)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DeleteCompanyTransaction = createAsyncThunk(
  'company-transaction-delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/delete-company-transaction/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EditCompanyTransaction = createAsyncThunk(
  'company-transaction-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/edit-company-transaction/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetCompanyTransactionReport = createAsyncThunk(
  'get-company-transaction-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/get-company-transaction-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CompanyTransactionPrintReport = createAsyncThunk(
  'company-transaction-print-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/company-transaction-print-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CompanyTransactionExcelReport = createAsyncThunk(
  'company-transaction-excel-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/company-transaction-excel-report`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const GetCanteenCash = createAsyncThunk(
  'get-canteen-cash',
  async (type: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/get-canteen-cash/` + type)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CreateCanteenTransaction = createAsyncThunk(
  'canteen-transaction-store',
  async (data: {}, thunkAPI) => {
    try {
      return await axios.post(`${api}dua-payments/store-canteen-transaction`, data)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DeleteCanteenTransaction = createAsyncThunk(
  'canteen-transaction-delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/delete-canteen-transaction/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EditCanteenTransaction = createAsyncThunk(
  'canteen-transaction-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/edit-canteen-transaction/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetCanteenTransactionReport = createAsyncThunk(
  'get-canteen-transaction-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/get-canteen-transaction-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CanteenTransactionPrintReport = createAsyncThunk(
  'canteen-transaction-print-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/canteen-transaction-print-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CanteenTransactionExcelReport = createAsyncThunk(
  'canteen-transaction-excel-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/canteen-transaction-excel-report`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)
export const journalClearAccounts = createAsyncThunk(
  'journal-accounts-clear',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/journal-accounts-clear`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getFinanceReport = createAsyncThunk(
  'get-finance-report',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}dua-payments/get-finance-report`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const printFinanceReport = createAsyncThunk(
  'print-finance-report',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}dua-payments/print-finance-report`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const excelFinanceReport = createAsyncThunk(
  'excel-finance-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}dua-payments/excel-finance-report`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const getCashReport = createAsyncThunk('get-cash-report', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}dua-payments/get-cash-report`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const printCashReport = createAsyncThunk('print-cash-report', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}dua-payments/print-cash-report`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type PaymentsState = {
  errors: any
}

const initialState: PaymentsState = {
  errors: '',
}

export const paymentsSlice = createSlice({
  name: 'dua-payments',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = paymentsSlice.actions
export default paymentsSlice.reducer
